import {
  getThemeColor,
} from '@qmulus/ui/utils/css.ts';
import {
  Chart,
} from 'chart.js';

import {
  getValueFromCssVariable,
} from '@/utils/css.ts';

/**
 * Chart.js keeps its default font and its text and grid colors as plain values, so they are read
 * from the theme again whenever it changes. Without the stylesheet, e.g. in unit tests, the defaults stay.
 */
export function applyChartThemeDefaults() {
  Chart.defaults.color = getThemeColor('--chart-text') || Chart.defaults.color;
  Chart.defaults.borderColor = getThemeColor('--chart-border') || Chart.defaults.borderColor;
  Chart.defaults.font.family = getValueFromCssVariable('--font-family') || Chart.defaults.font.family;
}

/**
 * Charts measure their labels with the font that is loaded when they draw, so a chart drawn before
 * its font has loaded keeps the layout of the fallback font, e.g. other label rotations and axis
 * widths. A font that fails to load is left to the fallback.
 */
export async function loadChartFonts(): Promise<void> {
  const fontFamily = getValueFromCssVariable('--font-family');
  if (fontFamily === '') {
    return;
  }
  await Promise.allSettled([
    document.fonts.load(`normal 1em ${fontFamily}`),
    document.fonts.load(`bold 1em ${fontFamily}`),
  ]);
}

/**
 * Redraws the open charts with the defaults of the active theme, once its font has loaded. Colors a
 * chart read from the theme itself, such as the color of a line, keep their value until the chart
 * is created again.
 */
export async function refreshChartTheme(): Promise<void> {
  applyChartThemeDefaults();
  await loadChartFonts();
  Object.values(Chart.instances).forEach((chart) => chart.update());
}
